import React, { useState, useRef, useEffect } from "react";
import _ from "lodash";
import { Spinner } from "react-rainbow-components";
import SmallAddButton from "./Buttons/SmallAddButton";
import SearchBar from "./SearchBar";
import TippyIcon from "./TippyIcon";
import FilterBadge from "./Badge/FilterBadge";
import DataTableFilter from "./Filters/DataTableFilter";
import { KonfhubButton } from "./Buttons";
import BulkAttendees from "./BulkUpload/BulkAttendees";
import DownloadIcon from "../../assets/img/DownloadWhite.svg";
import { capitalizeFirst, eventCity } from "../../Utils/helpers";
import useIsMobile from "../../Utils/useForceUpdate";
import LockableButton from "../Molecule/Buttons/LockableButton";
import DETCode from "../Atom/DETCode/DETCode";
import Dropdown from "./Dropdown";
import RegenerateTickets from "./RegenerateTickets/RegenerateTickets";
import { COMPONENT_HEADINGS, JS_TYPES } from "../../reusable/common";

// import downloadIcon from "../../assets/img/common/DownloadRedColor.svg"


// Header - Title, searchbar, and a button
const SectionHeader = ({
	tempData,
	heading,
	setSearchFunction,
	search,
	dropDown,
	buttonName,
	onButtonClick,
	onButtonLoading = false,
	disabledButton,
	credits,
	onClickOfCredits,
	decsription,
	tooltipButton,
	isFilter,
	getDataFunction,
	perPage,
	eventId,
	filterParams,
	setFilterParams,
	showUploadAttendees,
	refreshData,
	refreshDataLoading,
	onCallFunction,
	headerMargin,
	refreshHeaderComponent,
	restrictedButton = false,
	customFilterComp = false,
	customFilter = false,
	setCustomFilter = false,
	searchPlaceholder = "Search...",
	prop,
	bulkUploadDetails,
	listOfCustomCheckins,
	formik,
	handleDropdownSelect = false,
	selectedDropdownOption = false,
	dropdownOptions = false,
	isDefault = false,
	checkinId = false,
	isDangerousHtml= false
}) => {
	const [selectedFilters, setSelectedFilters] = useState([]); // This will contain the selected filters if any
	const [filterToRemove, setFilterToRemove] = useState(false); // This will contain the neccessary details of the filter that needs to be removed
	const [bulkmodal, setBulkModal] = useState(false); // Modal state
	const [selectedOption, setSelectedOption] = useState({}); // Track selected option for each dropdown
	const attendeesCount = prop?.prefeventinfo?.attendees_count;
	const isMobile = useIsMobile(450);
	const isDubaiEvent = eventCity(prop?.eventInfo?.city)
	const [showDropdown, setShowDropdown] = useState(false);
	const dropdownRef = useRef(null);
	const COMPONENT_HEADING = {
		CHECKED_IN_ATTENDEES: "Checked-in Attendees",
		ALL_ATTENDEES: "Attendees"
	};

	const BULK_ACTION = {
		REGENERATION_TICKETS: "Regenerate Tickets",
		BULK_UPLOAD: "Bulk Upload"
	};
	const handleButtonClick = () => {
		setShowDropdown((prev) => !prev);
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setShowDropdown(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);


	const handleSelectOption = (option) => {
		setSelectedOption(option);
		setShowDropdown(false);
		setBulkModal(true)
	};

	return (
		<>
			<div
				className={`d-md-flex alignCustomY mb-${headerMargin ? headerMargin : "3"
					}`}
			>
				{refreshHeaderComponent ? (
					<>{refreshHeaderComponent}</>
				) : (
					<div className="d-flex align-items-start align-items-sm-center flex-fill flex-grow-1">
						<span className="sectionTitle mt-0 mt-sm-3">{heading}</span>
						{refreshData && (
							<span className="refresh-con ml-3" onClick={() => refreshData()}>
								{refreshDataLoading ? (
									<Spinner size="xx-small" type="arc" variant="brand" />
								) : (
									<TippyIcon content="Refresh">
										<i className="fas fa-redo refresh-icon"></i>
									</TippyIcon>
								)}
							</span>
						)}
						{credits !== undefined && (
							<TippyIcon content="Request Credits" placement="bottom">
								<div className="d-inline">
									<SmallAddButton
										className="ml-2"
										btnType="primary"
										onClick={onClickOfCredits}
									>
										Available Credits: {credits}
									</SmallAddButton>
								</div>
							</TippyIcon>
						)}
					</div>
				)}

				{/* Search bar for datatable */}
				{setSearchFunction != null && (
					<div
						className={`d-flex d-sm-${heading === COMPONENT_HEADINGS.CHECKED_IN_ATTENDEES ? "flex align-items-center" : ""
							} mr-${heading === COMPONENT_HEADINGS.CHECKED_IN_ATTENDEES || !buttonName ? "0" : "4"
							} mt-1 mb-4 mb-sm-1`}
					>
						<SearchBar
							containerClass={heading === COMPONENT_HEADINGS.CHECKED_IN_ATTENDEES ? "searchInputBox_checkedIn" : "searchIconContainer"}
							search={search}
							setSearchFunction={setSearchFunction}
							searchPlaceholder={searchPlaceholder}
						/>

						{(heading === COMPONENT_HEADINGS.CHECK_IN_ACCESS || heading === COMPONENT_HEADINGS.CHECKED_IN_ATTENDEES) && (<>
							<div className="w-100 pl-2">
								<Dropdown
									options={dropdownOptions}
									id="dropdown_select"
									onChange={handleDropdownSelect}
									disabled={false}
									value={selectedDropdownOption}
								/>
							</div >
							{heading == COMPONENT_HEADINGS.CHECKED_IN_ATTENDEES && (<div className={"px-3 bulk_upload_button"}>
								<KonfhubButton
									disabled={disabledButton}
									className={"quaternary-btn"}
									onClick={handleButtonClick}
								>
									Reset Check-ins
								</KonfhubButton>
								{showDropdown && listOfCustomCheckins.length > 0 && (
									<div ref={dropdownRef} className="absolute mt-2 w-48 bg-white border rounded shadow-lg z-10">
										<ul className="text-left">
											{listOfCustomCheckins.map((item, index) => (
												<li
													key={index}
													className="px-4 py-2 cursor-pointer"
													onClick={() => {
														if (typeof onCallFunction === JS_TYPES.FUNCTION) {
															onCallFunction(item);
														}
														setShowDropdown(false);
													}}
												>
													{item.checkin_name}
												</li>
											))}
										</ul>
									</div>
								)}
							</div>)}
						</>
							// </TippyIcon>
						)}

						{
							isFilter && isMobile && (
								<div className="filter_options_mobile ml-3">
									<DataTableFilter
										heading={heading}
										getDataFunction={getDataFunction}
										setFilterParams={setFilterParams}
										filterParams={filterParams}
										setSelectedFilters={setSelectedFilters}
										perPage={perPage}
										search={search}
										eventId={eventId}
										filterToRemove={filterToRemove}
										setFilterToRemove={setFilterToRemove}
										tempData={tempData}
										view="mobile"
										{...(isDefault && { isDefault })}
										{...(checkinId && { checkinId })}
										isDubaiEvent={isDubaiEvent.isDubaiEvent}

									/>
								</div>
							)
						}

						{
							heading === COMPONENT_HEADING.ALL_ATTENDEES && !showUploadAttendees && selectedOption === BULK_ACTION.BULK_UPLOAD && (
								<div className="filter_options_mobile ml-3">
									<BulkAttendees type="secondary" eventId={eventId} view="mobile" bulkUploadDetails={bulkUploadDetails} prop={prop} bulkmodal={bulkmodal} setBulkModal={setBulkModal} heading={heading} />
								</div>
							)
						}
					</div >
				)}

				{/* custom filter component for whatsapp attendee analytics  */}
				{
					customFilterComp && (
						<div className="ml-0 ml-md-3">{customFilterComp}</div>
					)
				}

				{/* Filter Option Component*/}
				{
					isFilter && !isMobile && (
						<div className="filter_options_desktop mt-3 mt-sm-0">
							<DataTableFilter
								heading={heading}
								getDataFunction={getDataFunction}
								setFilterParams={setFilterParams}
								filterParams={filterParams}
								setSelectedFilters={setSelectedFilters}
								perPage={perPage}
								search={search}
								eventId={eventId}
								filterToRemove={filterToRemove}
								setFilterToRemove={setFilterToRemove}
								view="desktop"
								tempData={tempData}
								isDubaiEvent={isDubaiEvent.isDubaiEvent}
								{...(isDefault && { isDefault })}
								{...(checkinId && { checkinId })}
							/>
						</div>
					)
				}

				{
					heading == COMPONENT_HEADING.ALL_ATTENDEES &&


					(<div className="filter_options_desktop mt-3 mt-sm-0">
						{/* Bulk Upload Dropdown Button */}
						<div className={"pr-1 bulk_upload_button"}>
							<KonfhubButton btnType={"secondary"} onClick={handleButtonClick}>
								Bulk Actions
							</KonfhubButton>

							{/* Dropdown Menu */}
							{showDropdown && (
								<div ref={dropdownRef} className="absolute mt-2 w-48 bg-white border rounded shadow-lg z-10">
									<ul className="text-left">
										<li className="px-4 py-2 cursor-pointer option_color" onClick={() => handleSelectOption(BULK_ACTION.BULK_UPLOAD)}>
											Bulk Upload Attendees

										</li>
										{attendeesCount > 0 && (<li className="px-4 py-2 cursor-pointer option_color" onClick={() => handleSelectOption(BULK_ACTION.REGENERATION_TICKETS)}>
											Regenerate Tickets
										</li>)}
									</ul>
								</div>
							)}
						</div>
					</div>)
				}

				{
					(
						<div>
							{heading === COMPONENT_HEADING.ALL_ATTENDEES && selectedOption === BULK_ACTION.REGENERATION_TICKETS && (
								<div className="filter_options_mobile ml-3">
									<RegenerateTickets type="secondary" eventId={eventId} view="mobile" bulkmodal={bulkmodal} setBulkModal={setBulkModal} />
								</div>
							)}
						</div>
					)
				}
				{
					heading == COMPONENT_HEADING.ALL_ATTENDEES && !showUploadAttendees && (
						<>
							<div className="filter_options_desktop mt-3 mt-sm-0">
								<BulkAttendees type="secondary" eventId={eventId} view="desktop" prop={prop} bulkUploadDetails={bulkUploadDetails} heading={heading} />
							</div>
							<div className="filter_options_desktop ml-3">
								{isDubaiEvent.isDubaiEvent && <DETCode
									eventId={eventId}
									view="mobile"
									buttonText={"DET Codes"}
									btnType={"secondary"}
									showOverview={true}
									redirectToDETCodePage={true}
								/>}
							</div>
						</>
					)
				}






				{
					(showUploadAttendees == true) ? (
						""
					) : (
						<div className="pb-lg-3 pb-md-3 pb-0 section_header_buttonClassName mt-0 mt-lg-3 mt-md-3">
							<TippyIcon content={tooltipButton} placement="bottom">
								<div className="">
									{buttonName != null && (
										<LockableButton
											isLoading={onButtonLoading}
											btnType="tertiary"
											disabled={disabledButton || onButtonLoading}
											isRestricted={restrictedButton}
											onClick={() => {
												onButtonClick();
											}}
											className={heading === COMPONENT_HEADINGS.CHECKED_IN_ATTENDEES || heading === COMPONENT_HEADINGS.ATTENDEES ? "padding_download_icon" : ""}
										>
											{heading === COMPONENT_HEADINGS.CHECKED_IN_ATTENDEES || heading === COMPONENT_HEADINGS.ATTENDEES ? <img src={DownloadIcon} maxWidth={"0"} /> : buttonName}
										</LockableButton>
									)}
								</div>
							</TippyIcon>
						</div>
					)
				}
				<style jsx>{`
					.alignCustomY {
						align-items: stretch;
						flex-flow: row nowrap;
						justify-content: space-around;
						align-content: space-between;
						align-items: center;
					}
					.userCredits-button-container {
						border: 1px solid #ddd;
						padding: 5px 10px;
						margin-right: 5px;
						min-width: 130px;
						position: relative;
						border-radius: 3px;
						// display: flex;
						align-items: center;
						justify-content: center;
					}
					.searchIconContainer {
						width: 250px;
					}
					.head-cont {
						border-bottom: 1px solid #c3cddf78;
					}
					.flt-head {
						font-weight: 500;
						color: #572148;
						font-size: 18px;
					}
					.btn-wrap {
						position: absolute;
						background: white;
						bottom: 0px;
						width: 65%;
						padding: 0.7rem;
						right: 0px;
						border-top: 1px solid #c3cddf78;
					}
					.fltBtn {
						border: 1px solid #cdd4db;
						border-radius: 2px;
						background: transparent;
						padding: 5px 10px;
						white-space: nowrap;

					}
					.dropBtn {
						position: relative;
					}
					.l-side {
						background-color: #f6f7f9;
						width: 35%;
						height: 301px;
						float: left;
					}
					.r-side {
						position: relative;
						overflow: auto;
						width: 65%;
						background-color: white;
						padding: 10px;
						height: 298px;
						padding-top: 0.7rem !important;
					}
					.r-side label {
						display: inline;
					}
					.fil-btn {
						border: none;
						background-color: transparent;
						padding: 5px 10px 5px 3px;
						cursor: pointer;
					}
					.fil-btn:hover {
						background-color: #eae5e9;
					}
					.fil-btn-active {
						background-color: #572148;
						color: white;
						border: none;
						padding: 5px 10px 5px 3px;
						cursor: pointer;
					}
					.cnl-btn {
						background-color: transparent;
						padding: 2px 20px;
						color: #dc3545;
						border: 2px solid #dc3545;
						border-radius: 2px;
					}
					.rst-btn {
						background-color: transparent;
						padding: 2px 20px;
						color: #dc3545;
						border: none;
					}
					.apl-btn {
						float: right;
						background-color: #dc3545;
						padding: 2px 20px;
						color: White;
						border: 2px solid #dc3545;
						border-radius: 2px;
					}
					.refresh-icon {
						opacity: 1;
						transition: opacity 0.1s, transform 0.2s !important;
					}
					.refresh-con {
						position: relative;
						display: flex;
						justify-content: center;
						align-items: center;
						transition: 0.2s all;
					}
					.refresh-con i {
						font-size: 11px;
						margin-left: -9px;
						transform: translateY(0px);
					}
					.refresh-con:hover {
						transform: scale(1.1);
					}
					.refresh-con:hover .refresh-icon {
						color: #572148 !important;
						transform: scale(1);
						opacity: 1 !important;
					}
					.filter_icon {
						width: 36px;
						height: 36px;
						border-radius: 2px;
						border: 1px solid #CDD4DB;
					}
					.download_icon_white {
						width: 44px;
						height: 36px;
						border-radius: 2px;
						background: #DC3545;
						padding: 0px 8px;
						color: white;
					}
					.upload_icon_white {
						width: 36px;
						height: 36px;
						border-radius: 2px;
						background: #DC3545;
						padding: 0px 8px;
						color: white;
					}
				.quaternary-btn{
						white-space: nowrap;
						    padding: 0.2rem 1.2rem;

					}
					.searchInputBox_checkedIn {
						align-self: center !important;
					}

					.bulk_upload_button {
						position: relative;
					}

					.bulk_upload_button .absolute {
						position: absolute;
						top: 100%;
						left: 0;
						z-index: 1000;
						background: white;
						border: 1px solid #e2e8f0;
						border-radius: 0.375rem;
						box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
						width: 100%;
						font-family: Hind;
						font-weight: 400;
						font-size: 14px;
						line-height: 24px;
						color: #6D7780;
					}

					.bulk_upload_button ul {
						list-style-type: none;
						padding: 0;
						margin: 0;
					}

					.bulk_upload_button li {
						padding: 8px 12px;
						cursor: pointer;
					}

					.bulk_upload_button li:hover {
						background-color: #572148;
						color: #fff;
					}

					.option_color{
						color:#333333 !important;}

					.option_color:hover {
						color: white !important;
					
					}
												
					.padding_download_icon{
						padding: 6px 11px
					}


					@media (max-width: 450px) {
						.section_header_buttonClassName {
							margin-top: 10px;
						}
						.filter_options_desktop {
							display: none;
						}
						.refresh-con {
							margin-top: 7px !important;
						}
					}
					@media (min-width: 450px) {
						.filter_icon {
							display: none !important;
						}
						.download_icon_white {
							display: none !important;
						}
						.filter_options_mobile {
							display: none;
						}
					}
				`}</style>
			</div>
			{decsription && !isDangerousHtml && (
				<p
					className="sectionDesc mb-0"
					style={{
						transform: "translateY(-20px)",
					}}
				>
					{decsription}
				</p>
			)}
			{decsription && isDangerousHtml && (
					<p
						className="sectionDesc mb-0"
						style={{
						transform: "translateY(-20px)",
						}}
						dangerouslySetInnerHTML={{ __html: decsription }}
					/>
					)}

			{/* Selected Filter Badges */}
			{
				isFilter && !_.isEmpty(selectedFilters) && (
					<div className="mb-2">
						{selectedFilters.map((filterObj) => (
							<FilterBadge
								onClick={() => {
									setFilterToRemove([
										`${filterObj.filterType}-${filterObj.statusNo}`,
										!!filterObj.isTicket,
										true,
									])
								}
								}
							>
								{filterObj.filterName}
							</FilterBadge>
						))}
					</div>
				)
			}
			{/* Selected Filter Badges for  attendee analytics*/}
			{
				customFilter && !_.isEmpty(customFilter) && (
					<div className="mb-2">
						<>
							{customFilter && (
								<FilterBadge
									onClick={() => {

										setCustomFilter('');
									}}
								>
									{capitalizeFirst(customFilter)}
								</FilterBadge>
							)}
						</>

					</div>
				)
			}
		</>
	);
};
export default React.memo(SectionHeader);